





















import { computed, defineComponent, ref, toRefs } from '@nuxtjs/composition-api'
import { useClassifiedForm } from '~/compositions/form'
import { formFieldProps } from '~/constants/form'
import { useDep } from '~/compositions/dependency-container'
import FormValidationBuilder from '~/builders/form/FormValidationBuilder'
import FieldError from '~/components/car/classifieds/form/fieldsets/fields/FieldError.vue'
import { Ref } from '@vue/composition-api'
import { ciYoutube } from '~/icons/source/solid/youtube'
import { defineComponentTranslations } from '~/utils/i18n'
import { useI18n } from '~/compositions/i18n'

export default defineComponent({
  props: formFieldProps,
  components: { FieldError },
  setup(props) {
    const { name, specs } = toRefs(props)
    const value = ref<string>('')
    const { t } = useI18n()
    const onValue = (v: Ref<any>) => {
      value.value = v.value || ''
    }

    const formValidationBuilder = useDep(FormValidationBuilder)

    const { error, isValid, debouncedValueChanged } = useClassifiedForm(props, {
      onValue
    })

    function handleTextInput(url: string, validateOnly: boolean = false) {
      if (url === '' && error?.value) {
        error.value = null
      } else {
        formValidationBuilder
          .new(error)
          .required(specs.value.required, url)
          .youtubeLinkIsValid(url)
          .validate()
      }

      if (!validateOnly) {
        debouncedValueChanged(name.value, url)
      }
    }

    const placeholder = computed(() => specs.value.placeholder)

    return { value, error, isValid, handleTextInput, placeholder, ciYoutube, t }
  },
  i18n: defineComponentTranslations({
    youtube_description: {
      en:
        'Upload your classified video to YouTube, set it to "Unlisted" or "Public" and add the link here',
      el:
        'Ανέβασε το video της αγγελίας σου στο YouTube, όρισέ το ως "Μη καταχωρισμένο" ή "Δημόσιο" και πρόσθεσε τον σύνδεσμο εδώ'
    }
  })
})
